<div class="flex gap-1rem">
  <div class="flex-direction-column justify-center">
    <span class="font-mobile color-primary">N. remetente</span>
    <div class="flex-direction-column">
      <span class="font-mobile">{{ sessao?.conta?.nome }}</span>
      <span class="font-mobile">{{ ' | ' + (sessao?.conta?.numero | celularMask) }}</span>
    </div>
  </div>
  <div class="flex-direction-column justify-center">
    <span class="font-mobile color-primary">ID</span>
    <span class="font-mobile">{{ sessao?.id ?? '--' }}</span>
  </div>
</div>
